import { render } from "./FormComponent.vue?vue&type=template&id=0e419658&scoped=true"
import script from "./FormComponent.vue?vue&type=script&lang=js"
export * from "./FormComponent.vue?vue&type=script&lang=js"

import "./FormComponent.vue?vue&type=style&index=0&id=0e419658&scoped=true&lang=css"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e419658"]])

export default __exports__